module.exports = __webpack_public_path__ + "images/emoji/nine.f9e6be02a4415a2c23fc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/nine.png
// module id = rCC2
// module chunks = 24